import React from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../../utils/classNames';

var formatPlatformNames = function formatPlatformNames(platforms) {
  var platformTagOrder = ['PS5', 'PS4', 'PC', 'PS VR'];
  var PLATFORM_MAX_COUNT = 2;
  var platformTags = [];
  platformTagOrder.forEach(function (tag, tagIndex) {
    if (platforms.indexOf(platformTagOrder[tagIndex]) > -1) {
      platformTags.push(platformTagOrder[tagIndex]);
    }
  });
  return platformTags.slice(0, PLATFORM_MAX_COUNT);
};
/**
 * Responsible for the layout and display of game related platform tags
 */


var PlatformTags = function PlatformTags(_ref) {
  var platformNames = _ref.platformNames,
      qa = _ref.qa,
      className = _ref.className,
      onGraphic = _ref.onGraphic,
      disabled = _ref.disabled;
  var formattedNames = formatPlatformNames(platformNames.map(function (platform) {
    return platform === 'PSPC' ? 'PC' : platform;
  }));

  var _PlatformTags$getClas = PlatformTags.getClassName({
    className: className,
    onGraphic: onGraphic,
    disabled: disabled
  }),
      root = _PlatformTags$getClas.root,
      platformTagClass = _PlatformTags$getClas.platformTag;

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: root,
    "data-qa": qa
  }, formattedNames.map(function (name, i) {
    return /*#__PURE__*/React.createElement("span", {
      "data-qa": "".concat(qa, "#tag").concat(i),
      className: platformTagClass,
      key: name
    }, name);
  })));
};

var cx = classNamesFor(PlatformTags);

PlatformTags.getClassName = function (_ref2) {
  var onGraphic = _ref2.onGraphic,
      disabled = _ref2.disabled;
  return {
    root: cx('psw-l-cluster', 'psw-l-gap-2'),
    platformTag: cx('psw-platform-tag', 'psw-p-x-2', 'psw-l-line-left', 'psw-t-tag', onGraphic && 'psw-on-graphic', disabled && 'psw-is-disabled')
  };
};

PlatformTags.defaultProps = {
  className: '',
  qa: '',
  onGraphic: false,
  disabled: false
};
PlatformTags.propTypes = {
  /**
   * Additional classes to apply to the component, for layout positioning only.
   */
  className: PropTypes.string,

  /**
   * QA automation  id, should identify the component on the page
   */
  qa: PropTypes.string,

  /**
   * The accepted platforms for display
   */
  platformNames: PropTypes.arrayOf(PropTypes.oneOf(['PS4', 'PS5', 'PSPC', 'PS VR'])).isRequired,

  /**
   * Whether or not the tags are placed on top of a graphic
   */
  onGraphic: PropTypes.bool,

  /**
   * Whether or not to disable the tags as disabled
   */
  disabled: PropTypes.bool
};
export default PlatformTags;